<template>
  <v-container class="pt-0" style="height: 100%; background-color: #ffffff">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="warranty"
          :redirect_name="redirect_name"
        />
      </v-col>
    </v-row>

    <v-row class="px-2 mt-2">
      <v-col cols="12" class="py-1 mt-1" style="height: fit-content">
        <div class="d-flex" style="gap: 14px; z-index: 1">
          <div class="d-flex align-center" style="min-width: 64px">
            <div
              class="d-flex align-center justify-center"
              style="
                width: 64px;
                height: 64px;
                border-radius: 8px;
                overflow: hidden;
              "
              :style="{
                background: setBackgoundColorImage(),
              }"
            >
              <v-img
                v-if="
                  dataItem.product_image && dataItem.product_image.length > 0
                "
                :src="dataItem.product_image[0]"
                style="width: 100%; height: 100%; object-fit: contain"
                @error="onImageError(dataItem, 'product_image', 0)"
              >
              </v-img>
              <v-icon v-else :color="getFontColorBasedOnBg()" size="40"
                >mdi-package-variant-closed</v-icon
              >
            </div>
          </div>
          <div class="d-flex flex-column" style="width: 100%">
            <div class="d-flex justify-space-between" style="gap: 4px">
              <p
                class="text-start mb-0 pb-0 font-weight-bold"
                style="
                  font-size: 20px;
                  word-break: break-word;
                  line-height: 1.3;
                "
              >
                {{ dataItem.product_name }}
              </p>
              <div class="d-flex justify-end">
                <v-chip
                  class="font-weight-bold"
                  :style="{
                    'background-color': chipStatus(dataItem.current_status).bg,
                    color: chipStatus(dataItem.current_status).font,
                  }"
                  dark
                  small
                >
                  {{ $t(`warrantyStatus.${dataItem.current_status}`) }}
                </v-chip>
              </div>
            </div>
            <div class="d-flex align-center my-2" style="gap: 4px">
              <div style="color: #757575; font-size: 14px">
                {{ $t("expiredAt2") }} :
              </div>
              <v-icon small :color="dataItem.is_expired ? '#f44336' : '#757575'"
                >mdi-calendar</v-icon
              >
              <div
                style="font-size: 14px"
                :style="{
                  color: dataItem.is_expired ? '#f44336' : '#757575',
                }"
              >
                {{ dataItem.expired_at | formatDate }}
              </div>
              <v-chip
                v-if="dataItem.is_expired"
                class="font-weight-bold"
                :style="{
                  'background-color': chipStatus(dataItem.status).bg,
                  color: chipStatus(dataItem.status).font,
                }"
                dark
                small
              >
                {{ $t(`warrantyStatus.${dataItem.status}`) }}
              </v-chip>
            </div>
          </div>
        </div>

        <!-- // ========== ========== Schema Report Type ========== ========== -->
        <div v-if="dataItem.warranty_form_schema_detail" class="my-2">
          <div
            class="mb-1"
            style="font-weight: 500; text-decoration: underline"
          >
            {{ $t("textForm") }}
          </div>
          <div>
            <div
              v-for="(item, index) in warrantySchemaFlat"
              :key="index"
              class="d-flex mb-1"
            >
              <div class="mr-2" style="max-width: 50%">
                {{ formatMyQuestion(item.name) }} :
              </div>
              <div>
                <!-- Image -->
                <div
                  v-if="checkTypeMyQuestion(item.name) === 'image'"
                  class="d-flex flex-wrap"
                  style="gap: 8px"
                >
                  <img
                    v-for="(itemImage, i) in formatMyDetail(item.name)"
                    :key="i"
                    style="
                      width: 100%;
                      max-width: fit-content;
                      max-height: 120px;
                      object-fit: contain;
                      border-radius: 4px;
                    "
                    :src="itemImage.content"
                    @click="handleClickPreviewFormQuestion(itemImage)"
                  />
                </div>
                <!-- Text -->
                <div
                  v-else-if="checkTypeMyQuestion(item.name) === 'text'"
                  style="
                    font-size: 16px;
                    white-space: pre-line;
                    word-break: break-word;
                  "
                >
                  {{ formatMyDetail(item.name) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <DialogPreviewFile
          :dialogOpen="filePreview.dialog"
          :fileUrl="filePreview.url"
          :fileName="filePreview.name"
          @onClose="handleClosePreview"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import moment from "moment";
import DialogPreviewFile from "../../../components/dialog-preview-file.vue";
import {
  adjustHslBrightness,
  checkTypeQuestion,
  formatDetail,
  formatFlatQuestion,
  formatQuestion,
  getFontColorBasedOnBg,
} from "../../../config/general-function";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    DialogPreviewFile,
  },

  data() {
    return {
      reportId: null,
      warrantyRegistrationId: null,
      dataItem: {
        id: null,
        site_id: null,
        employee_id: null,
        product_id: null,
        serial_number: null,
        image_receipt: null,
        warranty_start_date_type: null,
        start_date: null,
        expired_at: null,
        purchase_date: null,
        registration_date: null,
        activation_date: null,
        warranty_form_id: null,
        warranty_form_schema_detail: null,
        status: null,
        reject_reason: null,
        warranty_form_schema: null,
        warranty_form_start_date_type: null,
        warranty_form_duration_day: null,
        product_name: null,
        product_image: null,
      },

      warrantySchema: null,
      warrantySchemaFlat: [],

      filePreview: {
        dialog: false,
        url: "",
        name: "",
        description: "",
      },

      redirect_name: "",
      previousRouteName: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
      // ========== ========== ========== ==========
      if (!vm.previousRouteName) {
        vm.redirect_name = "warranty-list";
      } else {
        vm.redirect_name = "";
      }
    });
  },
  async created() {
    this.warrantyRegistrationId = this.$route.params?.id || null;
    this.getWarrantyRegistrationDetail();
  },
  methods: {
    setBackgoundColorImage() {
      const _color = this.site.color || "#0f4c81";
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${lighten}, ${_color})`;
      return _style;
    },
    getFontColorBasedOnBg() {
      const res = getFontColorBasedOnBg(this.site.color, "bw");
      return res;
    },
    onImageError(item, key, index) {
      if ([null, undefined, ""].includes(index)) {
        item[key] = null;
      } else {
        item[key][index] = null;
      }
    },
    chipStatus(param) {
      const color = {
        active: { bg: "#E8F5E9", font: "#4CAF50" },
        pending: { bg: "#FFF3E0", font: "#FF9800" },
        rejected: { bg: "#FFEBEE", font: "#F44336" },
        expired: { bg: "#E8EAF6", font: "#3F51B5" },
      };
      return {
        bg: color[param]?.bg || "#9E9E9E",
        font: color[param]?.font || "#ffffff",
      };
    },

    // ========== ========== Form ========== ==========
    formatMyQuestion(question) {
      return formatQuestion(question, this.warrantySchema);
    },
    formatMyDetail(question) {
      return formatDetail(
        this.dataItem.warranty_form_schema_detail[question],
        question,
        this.warrantySchema
      );
    },
    checkTypeMyQuestion(question) {
      return checkTypeQuestion(question, this.warrantySchema);
    },
    handleClickPreviewFormQuestion(param) {
      this.filePreview.url = param.content;
      this.filePreview.name = param.name;
      this.filePreview.dialog = true;
    },
    // ========== ========== ========== ==========

    async getWarrantyRegistrationDetail() {
      try {
        let response = await Axios.get(
          `warranty-registration/getWarrantyRegistrationDetail/${this.warrantyRegistrationId}`
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          let fetchData = dataResponse.data;
          this.dataItem = { ...fetchData };
          if (this.dataItem.warranty_form_schema) {
            this.warrantySchema = this.dataItem.warranty_form_schema;
            this.warrantySchemaFlat = formatFlatQuestion(this.warrantySchema);
          }
        } else {
          const targetRoute = this.$router.resolve({
            name: "main",
          });
          window.location.href = targetRoute.href;
        }
      } catch (err) {
        console.log("getWarrantyRegistrationDetail", err);
        this.$swal
          .fire({
            icon: "error",
            title: JSON.stringify(err?.response?.data),
            showConfirmButton: false,
            timer: 3000,
          })
          .then(() => {
            const targetRoute = this.$router.resolve({
              name: "main",
            });
            window.location.href = targetRoute.href;
          });
      }
    },
    // ========== ========== ========== ==========
    handleClickPreview(param) {
      this.filePreview.url = param.url;
      this.filePreview.name = param.name;
      this.filePreview.dialog = true;
    },
    handleClosePreview() {
      this.filePreview.dialog = false;
    },
    async handleClickDownload(event, param) {
      event.stopPropagation();
      this.isAppLoading(true);
      try {
        let filename = param.name;
        let response = await fetch(param.url, {
          cache: "no-cache",
        });
        let blob = await response.blob();
        let url = await URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.crossOrigin = "Anonymous";
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  watch: {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
.label-attachment {
  font-size: 16px;
  font-weight: 600;
}

.label-name {
  font-size: 16px;
  font-weight: 600;
}

.attachment-box {
  background-color: #ffffff;
  border: 1px solid #9e9e9e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.attachment-box:hover {
  background-color: #eeeeee;
}

::v-deep .v-input__slot {
  max-height: 120px !important;
}

::v-deep .v-text-field__slot {
  overflow-y: auto;
}

::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}
</style>
